/**
 * sessionDrillHelper
 *
 * Shared helper for opening a session detail from a link inside a right-panel page.
 * If the right panel can drill (cap = 1 deep), drills into the session detail using
 * the same panel. Otherwise falls back to a full /search navigate (Approach A).
 *
 * Used by PracticesSection (practice detail → session link) and
 * DiscoverySection (thread detail → session link).
 *
 * @module components/sessionDrillHelper
 */

import { eventBus } from '../core/utils.js';
import { API } from '../core/api.js';
import { SessionsSection } from '../sections/SessionsSection.js';

/**
 * Open a session detail from an inline link inside the current right panel.
 * @param {number|string} sessionNumber - Session number from the link's data attribute
 * @returns {Promise<void>}
 */
export async function openSessionInPanel(sessionNumber) {
  const num = typeof sessionNumber === 'number'
    ? sessionNumber
    : parseInt(sessionNumber, 10);
  if (!Number.isFinite(num)) return;

  const rightPanelManager = window.app?.modules?.rightPanelManager;
  if (rightPanelManager?.canDrill()) {
    try {
      const sessionNote = await API.getSessionNotesByNumber(num);
      if (sessionNote) {
        eventBus.emit('right-panel:drill', SessionsSection.buildDetailPayload(sessionNote));
        return;
      }
    } catch (err) {
      console.error('[sessionDrillHelper] Failed to load session for drill:', err);
    }
  }

  // Fallback: full navigate to /search
  eventBus.emit('navigate', { page: 'search', sessionNumber: num });
}
